module.exports = __webpack_public_path__ + "static/media/AngelListLogo.85c592a7.png";